import React from 'react';

const StartBuilding = () => {
  return (
    <>
      {/* Start Building with ASI1 */}
      <h3 className="text-2xl font-bold text-gray-800 mb-6">Start Building with ASI1</h3>
      <p className="text-gray-700 leading-relaxed mb-6">
        When you're ready to build autonomous agents and Web3 applications, ASI1 provides the tools and resources you need:
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
          <h4 className="font-semibold text-blue-700 mb-3">Quick Start Guide</h4>
          <p className="text-gray-700 text-sm mb-4">Follow our quickstart to make your first API call and deploy your first agent</p>
          <a 
            href="https://docs.asi1.ai/docs/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 font-medium text-sm"
          >
            View Documentation →
          </a>
        </div>

        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
          <h4 className="font-semibold text-blue-700 mb-3">API Reference</h4>
          <p className="text-gray-700 text-sm mb-4">Comprehensive API documentation for all ASI1 models and agent capabilities</p>
          <a 
            href="https://docs.asi1.ai/docs/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 font-medium text-sm"
          >
            Explore APIs →
          </a>
        </div>

        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
          <h4 className="font-semibold text-blue-700 mb-3">Agent Templates</h4>
          <p className="text-gray-700 text-sm mb-4">Ready-to-use agent templates for DeFi, trading, and Web3 applications</p>
          <a 
            href="https://asi1.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 font-medium text-sm"
          >
            Get Templates →
          </a>
        </div>
      </div>

      <div className="text-center">
        <a 
          href="https://asi1.ai/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors inline-block"
        >
          Start Building with ASI1
        </a>
      </div>
    </>
  );
};

export default StartBuilding;
